<button
  class="channel"
  [title]="text"
  [class.channel--active]="active"
  [class.channel--has-news]="news"
  [disabled]="active"
  (click)="onClick()">
  <span class="channel__name">{{ text }}</span>
  @if (news > 0) {
  <bau365-channel-count-badge [count]="news"></bau365-channel-count-badge>
  }
</button>
